import "./_import_files";

import "settings";
import svg4everybody from "svg4everybody";
import $ from "jquery";
import Page from "webPage/Page";
import PageAnimations from "webPage/PageAnimations";
import StickyNav from "StickyNav";
import CanvasImage from "./CanvasImage";
import GlobalEvents from "base/GlobalEvents";
import VideoHelper from "video/VideoHelper";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import "objectFitPolyfill";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }
    $("body").addClass("has-js").removeClass("no-js");

    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    Page.init();
    PageAnimations.start();
    new StickyNav($(".header"), $(".hero"));

    $('body').on('click', '.js-menu-btn', function () {
        $('body').toggleClass('nav-active');
        return false;
    }).on("click", ".modal__container", (e) => e.stopPropagation()).on("click", ".modal", () => {
        GlobalEvents.emit('website.modal.close');
        $("body").removeClass("modal-active");
        $(".modal--active").removeClass("modal--active");
        return false;
    }).on('click', '.js-watch-video', function () {
        let $modal = $(".js-video-modal");
        let $modalContent = $modal.find(".modal__container");

        let $caseStudy = $(this).parents("[data-video-id]");

        let $video = eotwJSXFactory('div');

        $modalContent.attr("style", "background: url('" + $caseStudy.find(".js-watch-video img").attr("src") + "') no-repeat center center; background-size: cover");

        let $wrap = eotwJSXFactory('div', {class: "video__wrapper video__wrapper--loading"}, [$video]);
        $modalContent.html($wrap);

        let player = VideoHelper.process($caseStudy.attr("data-provider"), $caseStudy.attr("data-video-id"), $video, {autoplay: true});

        player.on("loaded", () => {
            $wrap.addClass("video__wrapper--playing");
        });
        let fn = () => {
            GlobalEvents.off('website.modal.close', fn);
            player.destroy();
        };
        GlobalEvents.on('website.modal.close', fn);

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");

        return false;
    });

    FormValidator.attach($(".js-subscribe-form"), {
        inputOptions: {operator: 'your'}
    }).on("input:invalid", ({input}) => {
        input.$input.parents(".form__row").first().addClass("form__row--error");
    }).on("input:valid", ({input}) => {
        input.$input.parents(".form__row").first().removeClass("form__row--error");
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass("btn--loading");

        Ajax.post("equip", "subscribe", $form.serializeJSON(), Ajax.WEBSITE).then((data) => {
            $(".subscribe").addClass("subscribe--success").find("h4").text("Thanks for subscribing!");
            $form.remove();
        }).catch((e) => {
            $btn.removeClass("btn--loading");
            if (e.data && e.data.exception === 'HttpValidationException') {
                $form.data("Validator").handleValidationException(e);
            } else {
                alert(e.message);
            }
            console.log(e);
        });
    });


    new CanvasImage($(".hero__image"), window.HEADER_MASKS, $(".hero__image").attr("data-canvas-overlay"));

    $(".donate__background").each((_, el) => new CanvasImage($(el), window.DONATE_MASKS));

    setTimeout(CanvasImage.check_all_loaded, 500);
});

window.HEADER_MASKS = {
    0: [
        {
            'url': '/images/png/masks/home/home-hero--mobile-mask.png',
            'vPos': 'bottom',
            'hPos': 'center'
        }
    ],
    600: [
        {
            'url': '/images/png/masks/home/home-hero--mobile-mask.png',
            'vPos': 'bottom'
        }
    ],
    960: [
        {
            'url': '/images/png/masks/home/home-hero--laptop-mask.png',
            'vPos': 'bottom'
        }
    ],
    1180: [
        {
            'url': '/images/png/masks/home/home-hero--desktop-mask.png',
            'vPos': 'bottom'
        }
    ],
    1400: [
        {
            'url': '/images/png/masks/home/home-hero--huge-mask.png',
            'vPos': 'bottom'
        }
    ]
};

window.DONATE_MASKS = {
    0: [
        {
            'url': '/images/png/masks/home/subscribe/subscribe-mask-top--huge.png',
            'vPos': 'top',
            'hPos': 'center'
        }
    ],
    600: [
        {
            'url': '/images/png/masks/home/subscribe/subscribe-mask-top--huge.png',
            'vPos': 'top',
            'hPos': 'center'
        }
    ],
    960: [
        {
            'url': '/images/png/masks/home/subscribe/subscribe-mask-top--huge.png',
            'vPos': 'top',
            'hPos': 'center'
        }
    ],
    1200: [
        {
            'url': '/images/png/masks/home/subscribe/subscribe-mask-top--huge.png',
            'vPos': 'top',
            'hPos': 'center'
        }
    ]
};
